import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import DateFilter from "@/filter/date.filter"
import DateTimeFilter from "@/filter/dateTime.filter"
import vuetify from "./plugins/vuetify"
import i18n from "./locale/i18n"
import "material-design-icons-iconfont/dist/material-design-icons.css"
import "./assets/css/main.css"
import "./components"
import ApiService from "@/utils/api.service"
import capitalize from "@/filter/capitalize.filter"
import truncate from "@/filter/truncate.filter"
import VueMeta from "vue-meta"

Vue.config.productionTip = false
Vue.filter("date", DateFilter)
Vue.filter("truncate", truncate)
Vue.filter("dateTime", DateTimeFilter)
Vue.filter("capitalize", capitalize)

import VuetifyToast from "vuetify-toast-snackbar-ng"

ApiService.init()

Vue.use(VuetifyToast, {
  x: "right", // default
  y: "bottom", // default
  color: "info", // default
  icon: "info",
  timeout: 3000, // default
  dismissable: true, // default
  autoHeight: false, // default
  multiLine: false, // default
  vertical: false, // default
  shorts: {
    custom: {
      color: "purple",
    },
  },
  property: "$toast", // default
})
Vue.config.productionTip = false
Vue.use(require("vue-moment"))
new Vue({
  vuetify,
  VueMeta,
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app")
